import React, { useEffect, useState, useRef } from 'react';
import {
  GoogleMap,
  withScriptjs,
  withGoogleMap,
  Marker,
  Polyline,
  InfoWindow,
} from 'react-google-maps';
import bus from '../../images/yolobus1.png';
import config from '../../config';
import { apiCall } from '../../../service';

const Map = ({ vehicleNo, speed, address }) => {
  const mapRef = useRef(null);
  const [progress, setProgress] = useState([]);
  const [showInfo, setShowInfo] = useState(false);
  const [vehiclePath, setVehiclePath] = useState([]);
  const [calculatedPath, setCalculatedPath] = useState([]);
  let [vehicleDistance, setVehicleDistance] = useState([]);
  const [isAnimating, setIsAnimating] = useState(false);
  const [preLatLong, setPreLatLong] = useState({})

  const icon1 = {
    url: `${bus}`,
    scaledSize: new window.google.maps.Size(80, 80),
    anchor: new window.google.maps.Point(40, 40),
    scale: 1.5,
  };

  useEffect(() => {
    const getVehiclePath = async () => {
      try {
        const payload = {
          body: {
            vehicleNo: vehicleNo,
            lastTime: 40,
          },
          method: 'POST',
          host: config.apiEndpoints.getVehiclePath.host,
          endPoint: config.apiEndpoints.getVehiclePath.url,
        };
        const data = await apiCall(payload);
        if (data.length == 0) {
          try {
            if (vehicleNo != null) {
              const payload = {
                body: {
                  vehicleNo: vehicleNo,
                },
                method: 'POST',
                host: config.apiEndpoints.getVehiclelocation.host,
                endPoint: config.apiEndpoints.getVehiclelocation.url,
              };
              const data = await apiCall(payload);
              const latLongData = {
                lat: parseFloat(data.latitude || 0),
                lng: parseFloat(data.longitude || 0),
              };

              const vehicleLocation = data
              const vehiclePosition = {
                lat: Number(latLongData.lat),
                lng: Number(latLongData.lng),
                distance: 0,
              };

              const vehicleLocArr = [
                { latitude: Number(vehicleLocation?.latLong2?.split(",")[0]) || 0, longitude: Number(vehicleLocation?.latLong2?.split(",")[1]) || 0 },
                { latitude: Number(vehicleLocation.latitude), longitude: Number(vehicleLocation.longitude) },
              ]
              setTimeout(()=>{rotateIconBasedOnPath(vehicleLocArr)},50)
              setVehicleDistance([vehicleLocArr[vehicleLocArr.length-2],vehicleLocArr[vehicleLocArr.length-1]])
              if (mapRef.current) {
                mapRef.current.panTo(vehiclePosition);
              }
              setProgress([vehiclePosition])

            }
          } catch (error) {
            console.log(error);
          }
        }


        const position = data.map(position => ({
          lat: parseFloat(position.latitude),
          lng: parseFloat(position.longitude),
          distance: 0,
        }));
        const vehicleDistance = position.slice(-2);
        setVehicleDistance(vehicleDistance)
        const vehiclePosition = position.slice(-1);
        if (mapRef.current && vehiclePosition.length > 0) {
          mapRef.current.panTo(vehiclePosition[0]);
        }

        const vehicleLocation = data.slice(-3);
        // setVehicleLocation(vehicleLocation);
        setVehiclePath(position);
        setProgress(vehiclePosition);
        // rotateIconBasedOnPath(vehicleLocation);
        setTimeout(() => { rotateIconBasedOnPath(vehicleLocation) }, 50)
      } catch (error) {
        console.log(error);
      }
    };
    getVehiclePath();
    const intervalId = setInterval(() => {
      getVehiclePath();
    }, 10000);

    return () => clearInterval(intervalId);
  }, [vehicleNo]);

  const rotateIconBasedOnPath = (vehicleLocation) => {
    if (vehicleLocation.length > 0) {
      const point1 = vehicleLocation[0];
      const point2 = vehicleLocation[1];

      const point1LatLng = new window.google.maps.LatLng(
        Number(point1.latitude),
        Number(point1.longitude)
      );
      const point2LatLng = new window.google.maps.LatLng(
        Number(point2.latitude),
        Number(point2.longitude)
      );

      const angle = window.google.maps.geometry.spherical.computeHeading(
        point1LatLng,
        point2LatLng
      );


      const actualAngle = angle - 90;
      const marker = document.querySelector(`[src="${icon1.url}"]`);
      if (marker) {
        marker.style.transform = `rotate(${actualAngle}deg)`;
      }
    }
  };

  useEffect(() => {
    if (vehiclePath.length > 0) {
      calculateVehiclePath(vehiclePath);
    }
    if (vehicleDistance.length > 0) {
      calculateDistancePath(vehicleDistance)
    }
  }, [vehiclePath]);

  const calculateDistancePath = (path) => {
    const updatedVehiclePath = path.map((coordinates, i, array) => {
      if (i === 0) {
        return { ...coordinates, distance: 0 };
      }

      const { lat: lat1, lng: lng1 } = coordinates;
      const { lat: lat2, lng: lng2 } = array[i - 1];

      const latLong1 = new window.google.maps.LatLng(lat1, lng1);
      const latLong2 = new window.google.maps.LatLng(lat2, lng2);

      const distance = window.google.maps.geometry.spherical.computeDistanceBetween(
        latLong1,
        latLong2
      );

      return { ...coordinates, distance };
    });
    setVehicleDistance(updatedVehiclePath);
  };

  const calculateVehiclePath = (path) => {
    const updatedVehiclePath = path.map((coordinates, i, array) => {
      if (i === 0) {
        return { ...coordinates, distance: 0 };
      }

      const { lat: lat1, lng: lng1 } = coordinates;
      const { lat: lat2, lng: lng2 } = array[i - 1];

      const latLong1 = new window.google.maps.LatLng(lat1, lng1);
      const latLong2 = new window.google.maps.LatLng(lat2, lng2);

      const distance = window.google.maps.geometry.spherical.computeDistanceBetween(
        latLong1,
        latLong2
      );

      return { ...coordinates, distance };
    });
    setCalculatedPath(updatedVehiclePath);
  };

  const initialDate = new Date()

  const getDistance = () => {
    const differenceInTime = (new Date() - initialDate) / 1000;
    return ((differenceInTime * (speed * 5 / 18)));
  }

  const moveObject = () => {
    if (vehicleDistance.length < 2) return;
    const vehicle = vehicleDistance[1]
    
    if (!vehicle ) {
      setIsAnimating(false);
      return;
    }
    if(vehicle.lat===preLatLong.lat && vehicle.lng === preLatLong.lng){
      setPreLatLong(vehicle)
      setIsAnimating(false);
      return
    }
    let distance = getDistance()
    if (distance === 0) {
      setProgress([vehicleDistance[vehicleDistance.length - 1]]);
      return;
    }

    setIsAnimating(true);
    let index = 0;

    const animate = () => {
      setPreLatLong(vehicle)
      if (index < vehicleDistance.length - 1) {
        const start = vehicleDistance[index];
        const end = vehicleDistance[index + 1];

        if (start.lat === end.lat && start.lng === end.lng) {
          setProgress([start]);
          setIsAnimating(false);
          return;
        }

        const totalDistance = window.google.maps.geometry.spherical.computeDistanceBetween(
          new window.google.maps.LatLng(start.lat, start.lng),
          new window.google.maps.LatLng(end.lat, end.lng)
        );

        
        const distance = getDistance();
        const distanceCovered = Math.min(distance, totalDistance);

        const percentage = (distanceCovered / totalDistance);

        const lat = start.lat + (end.lat - start.lat) * percentage;
        const lng = start.lng + (end.lng - start.lng) * percentage;

        const currentHeading = window.google.maps.geometry.spherical.computeHeading(
          new window.google.maps.LatLng(start.lat, start.lng),
          new window.google.maps.LatLng(end.lat, end.lng)
        );
        const newHeading = window.google.maps.geometry.spherical.computeHeading(
          new window.google.maps.LatLng(start.lat, start.lng),
          new window.google.maps.LatLng(lat, lng)
        );

        if (newHeading >= currentHeading) {
          setProgress([{ lat, lng }]);

          const angle = window.google.maps.geometry.spherical.computeHeading(
            new window.google.maps.LatLng(start.lat, start.lng),
            new window.google.maps.LatLng(end.lat, end.lng)
          );

          const marker = document.querySelector(`[src="${icon1.url}"]`);
          if (marker) {
            marker.style.transform = `rotate(${angle - 90}deg)`;
          }
        }

        if (percentage < 1) {
          requestAnimationFrame(animate);
        } else {
          index++;
          animate();
        }
      } else {
        setProgress([vehicleDistance[vehicleDistance.length - 1]]);
        setIsAnimating(false);
      }
    };

    animate();
  };

  useEffect(() => {
    if (vehicleDistance.length > 0 || isAnimating) {
      moveObject();
    }
  }, [vehicleDistance]);


  const handleMarkerClick = () => {
    setShowInfo(!showInfo);
  };

  return (
    <div>
      <GoogleMap
        ref={mapRef}
        defaultZoom={16}
        defaultCenter={vehiclePath.length > 0 ? vehiclePath[0] : { lat: 24.272500, lng: 80.621880 }}
      >
        <Polyline
          path={calculatedPath}
          options={{
            // strokeColor: 'orange',
            strokeWeight: 0,
            strokeOpacity: 0.6,
            defaultVisible: true,
          }}
        />
        <Polyline
          path={vehicleDistance}
          options={{
            // strokeColor: '',
            strokeWeight: 0,
            strokeOpacity: 0.6,
            defaultVisible: true,
          }}
        />
        {progress.length >= 0 && (
          <>
            <Polyline path={progress} options={{ strokeColor: 'orange' }} />
            <Marker
              icon={icon1}
              position={progress[0] || progress}
              onClick={handleMarkerClick}
            />
            {showInfo && progress[0] && (
              <InfoWindow position={progress[0] || progress}>
                <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
                  <div>
                    <span style={{ color: 'green' }}>Address: </span> {address}
                  </div>
                  <div>
                    <span style={{ color: 'green' }}>Vehicle No: </span>{' '}
                    {vehicleNo}
                  </div>
                  <div>
                    <span style={{ color: 'green' }}>Speed : </span> {Math.round(speed)} km/hr
                  </div>
                </div>
              </InfoWindow>
            )}
          </>
        )}
      </GoogleMap>
    </div>
  );
};

export default withScriptjs(withGoogleMap(Map));
